export default __webpack_public_path__ + "locales/si/PeopleTranslations.json?hash=ef9cb1b99afcf6b77ed10067d4288c4d";